export const truncatedFileName = (filename, maxLength) => {
  if (!filename) return

  if (filename.length < maxLength) {
    return filename
  }

  const trunacatefilename =
    filename.substring(0, maxLength) + "..." + filename.substring(filename.length - 10, filename.length)

  return trunacatefilename
}
